import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';

export const NoBaseGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (environment.isWlmhEnabled) {
    return true;
  } else {
    return router.navigateByUrl('/login');
  }
};
